var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.buttons),function(button){return _c('button',{class:`md-button ${_vm.getClass(button.class)}`},[_c('i',{class:`fab fa-${_vm.getInfo(button.type)}`}),_vm._v(" "+_vm._s(_vm.getTitle(button.type))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }